import { render } from "./InstantPayoutAvailable.vue?vue&type=template&id=5f01ec52&scoped=true"
import script from "./InstantPayoutAvailable.vue?vue&type=script&lang=js"
export * from "./InstantPayoutAvailable.vue?vue&type=script&lang=js"

import "./InstantPayoutAvailable.vue?vue&type=style&index=0&id=5f01ec52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f01ec52"]])

export default __exports__